import type { SourceType } from '@grammarly/citation-generator'
import * as Contentful from 'contentful'

export enum KeywordSourceTypeRelationship {
  Equal = 'is equal',
  Mapped = 'is mapped',
  MostCommonly = 'is most commonly',
}

export type IndefiniteArticleType = 'a' | 'an' | 'definite article' | 'none'
export type DefiniteArticleType = 'the' | 'none'

export interface TypeCitationKeywordMetadataFields {
  indefiniteArticle: IndefiniteArticleType
  definiteArticle: DefiniteArticleType
  displayNameSingular: Contentful.EntryFields.Symbol
  displayNamePlural: Contentful.EntryFields.Symbol
  mlaSourceTypeRelationship?: KeywordSourceTypeRelationship
  mlaSourceType?: SourceType
  apaSourceTypeRelationship?: KeywordSourceTypeRelationship
  apaSourceType?: SourceType
  chicagoSourceTypeRelationship?: KeywordSourceTypeRelationship
  chicagoSourceType?: SourceType
}

export type TypeCitationKeywordMetaData = Contentful.Entry<TypeCitationKeywordMetadataFields>
